class MainProductCart extends HTMLElement
{
    swiper

    connectedCallback()
    {
        this.swiper = new Swiper('.main-product-cart .swiper', {
            speed: 500,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.main-product-cart .swiper-pagination',
                clickable: true,
                renderBullet: function( _index, className) {
                    return `<span class="${className}"></span>`
                }
            }
        })
    }

    disconnectedCallback()
    {
        this.swiper.destroy()
    }
}

customElements.define('main-product-cart', MainProductCart);